<doka-modal-wrapper (close)="closeModal()">
  <ng-template #title>{{ "Common.Edit" | i18nextEager }} {{ country().countryCode }} </ng-template>

  <ng-template #content>
    <div class="flex flex-col gap-lg">
      <doka-text-field
        [readonly]="true"
        [(ngModel)]="country().countryName"
        [label]="'MasterData.CountriesGrid.Name' | i18nextEager"
      ></doka-text-field>

      <doka-select
        [value]="selectedMainIsoCurrencyCode()"
        (valueChange)="selectedMainIsoCurrencyCode.set($any($event))"
        [label]="'MasterData.CountriesGrid.MainCurrency' | i18nextEager"
        [required]="true"
        [alert]="submitted() && !selectedMainIsoCurrencyCode() ? ('Common.Required' | i18nextEager) : ''"
      >
        @for (currencyCode of country().isoCurrencyCodes; track currencyCode) {
          <doka-select-option [value]="currencyCode" [label]="currencyCode" />
        }
      </doka-select>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="flx flex-col gap-sm w-full">
      <div class="flex w-full gap-md px-6 pt-4 items-center justify-end">
        <doka-button [disabled]="isLoading()" (click)="closeModal()" color="secondary">{{
          "Common.Cancel" | i18nextEager
        }}</doka-button>
        <doka-button
          type="submit"
          [disabled]="isLoading() || !selectedMainIsoCurrencyCode()"
          (click)="submit()"
          color="primary"
          >{{ "Common.Save" | i18nextEager }}</doka-button
        >
      </div>
    </div>
  </ng-template>
</doka-modal-wrapper>
